import React, { useRef, useState } from 'react';
// import emailjs from '@emailjs/browser';
import Spacing from "../Spacing";
// import HeroStyle2 from "../Hero/HeroStyle2";
import SectionHeading from "../SectionHeading";
import TestimonialSlider from "../Slider/TestimonialSlider";
import ServiceSlider from "../Slider/ServiceSlider";
import AboutStyle2 from "../About/AboutStyle2";
import Button from "../Button";
import { pageTitle } from "../../helpers/PageTitle";
import { Icon } from "@iconify/react";
import HeroStyle3 from "../Hero/HeroStyle3";
import AboutStyle4 from "../About/AboutStyle4";
import BlogHero from "../Post/BlogHero";
import { useTranslation } from 'react-i18next';



export default function MarketingAgencyPage({ darkMode }) {
  pageTitle("Halisi");

  const { t, i18n } = useTranslation(["marketing"]);

  const servideData = [
  {
    iconSrc: "/images/marketing-agency/service_icon_1.svg",
    title: t("services.service1.title"),
    subTitle: t("services.service1.substitle"),
  },
  {
    iconSrc: "/images/marketing-agency/service_icon_2.svg",
    title: t("services.service2.title"),
    subTitle: t("services.service2.substitle"),
  },
  {
    iconSrc: "/images/marketing-agency/service_icon_3.svg",
    title: t("services.service3.title"),
    subTitle: t("services.service3.substitle"),
  },
  {
    iconSrc: "/images/marketing-agency/service_icon_4.svg",
    title: t("services.service4.title"),
    subTitle: t("services.service4.substitle"),
  },
  {
    iconSrc: "/images/marketing-agency/service_icon_1.svg",
    title: t("services.service5.title"),
    subTitle: t("services.service5.substitle"),
  },
  {
    iconSrc: "/images/marketing-agency/service_icon_2.svg",
    title: t("services.service6.title"),
    subTitle: t("services.service6.substitle"),
  },
  {
    iconSrc: "/images/marketing-agency/service_icon_3.svg",
    title: t("services.service7.title"),
    subTitle: t("services.service7.substitle"),
  },

];

const testimonialData = [
  {
    text: t("recommendation.testimonialData1.text"),
    avatarName: t("recommendation.testimonialData1.avatarName"),
    avatarDesignation: t("recommendation.testimonialData1.avatarDesignation"),
    icon: '/images/testimonial/Frame1.png'
  },
  {
    text: t("recommendation.testimonialData2.text"),
    avatarName: t("recommendation.testimonialData2.avatarName"),
    avatarDesignation: t("recommendation.testimonialData2.avatarDesignation"),
    icon: '/images/testimonial/Frame2.png'
  },
  {
    text: t("recommendation.testimonialData3.text"),
    avatarName: t("recommendation.testimonialData3.avatarName"),
    avatarDesignation: t("recommendation.testimonialData3.avatarDesignation"),
    icon: '/images/testimonial/Frame3.png'
  },
  {
    text: t("recommendation.testimonialData4.text"),
    avatarName: t("recommendation.testimonialData4.avatarName"),
    avatarDesignation: t("recommendation.testimonialData4.avatarDesignation"),
    icon: '/images/testimonial/Frame4.png'
  },
  {
    text: t("recommendation.testimonialData5.text"),
    avatarName: t("recommendation.testimonialData5.avatarName"),
    avatarDesignation: t("recommendation.testimonialData5.avatarDesignation"),
    icon: '/images/testimonial/Frame5.png'
  },
  {
    text: t("recommendation.testimonialData6.text"),
    avatarName: t("recommendation.testimonialData6.avatarName"),
    avatarDesignation: t("recommendation.testimonialData6.avatarDesignation"),
    icon: '/images/testimonial/Frame6.png'
  },
  {
    text: t("recommendation.testimonialData7.text"),
    avatarName: t("recommendation.testimonialData7.avatarName"),
    avatarDesignation: t("recommendation.testimonialData7.avatarDesignation"),
    icon: '/images/testimonial/Frame7.png'
  },
];

  

  const form = useRef();
  const [confirmationMessage, setConfirmationMessage] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      let formData = formDataToJson(form.current)
      let { user_name, user_email, user_phone, user_message } = formData
      const response = await fetch(`
      https://docs.google.com/forms/d/e/1FAIpQLSe_rTs231PJVlRAIERtVwJQWTQW47fQHbNRUQOTMfO7XCgtZA/formResponse?entry.535584654=${user_name}&entry.1764387330=${user_email}&entry.917129849=${user_phone}&entry.1861751147=${user_message}`)

    } catch (error) {
      console.log("Error in form", error)
    }


    console.log(formDataToJson(form.current))
  };

  function formDataToJson(form) {
    const formData = new FormData(form);
    const jsonData = {};

    formData.forEach((value, key) => {
      jsonData[key] = value;
    });

    return jsonData;
  }

  const languageButton = i18n.language === 'en' ? 'he' : 'en';
  const isHebrew = languageButton === 'he';

  return (
    <>
      <HeroStyle3
        miniTitle="Halisi"
        title="We are <br/> King or <br/>Pawns"
        thumbnailSrc={
          darkMode
            ? ""
            : ""
        }
      />

      {/* <Spacing lg="125" md="70" /> */}
      <AboutStyle4
        id="content"
        thumbnailSrc="/images/digital-agency/about_1.jpeg"
        miniTitle={t("smallHeading.aboutMiniTitle")}
        title={t("smallHeading.aboutTitle")}
        subTitle={t("smallHeading.aboutSubtitle")}
        subTitle1={t("smallHeading.aboutSubtitle1")}
        subTitle2={t("smallHeading.aboutSubtitle2")}
        subTitle3={t("smallHeading.aboutSubtitle3")}
      />

      {/* WHO WE ARE  */}
      <section id="about">
        <div className="cs_height_150 cs_height_lg_75" />
        <AboutStyle2
          thumbnailSrc1="/others-image/about_img_1.png"
          thumbnailSrc2="/others-image/about_img_2.png"
          title={t("whoweare.whoweareTitle")}
          uperTitle={t("whoweare.whoweareUperTitle")}
          subTitle={t("whoweare.whoweareSubTitle")}
          subTitle1={t("whoweare.whoweareSubTitle1")}
          subTitle2={t("whoweare.whoweareSubTitle2")}
          subTitle3={t("whoweare.whoweareSubTitle3")}
        />
      </section>

      {/* SERVICES */}
      <section className="cs_p76_full_width" id="service">
        <Spacing lg="143" md="75" />
        <SectionHeading title={t("services.servicesTitle")} subTitle={t("services.servicesSubtitle")} />
        <Spacing lg="85" md="45" />
        <ServiceSlider data={servideData} />
      </section>

      {/* recommendation */}
      <section id="recommendation">
        <Spacing lg="143" md="75" />
        <SectionHeading
          title={t("recommendation.title")}
          subTitle={t("recommendation.subtitle")}
        />
        <TestimonialSlider layeredImages={[]} data={testimonialData} />
      </section>

      {/* <div className="container">
        <Spacing lg="125" md="70" />
        <FunFact data={funfactData} />
      </div> */}

      {/* blogs  */}
      <section>
        <Spacing lg="118" md="70" />
        <div className="container">
          <SectionHeading title={t("blogs.title")} subTitle={t("blogs.subtitle")} />
          <Spacing lg="85" md="45" />
        </div>
        <BlogHero />
        {/* <CaseStudy data={caseStudyData} /> */}
        <Spacing lg="100" md="60" />
        <div className="container">
          <div className="text-center">
            <Button btnText={t("blogs.btnBlogs")} btnUrl="/blog-list" />
          </div>
        </div>
      </section>

      <Spacing lg="20" md="80" />

      {/* contact form  */}
      <Spacing lg="75" md="60" />
       <section id="contact">
        <div className="container">
          <div className={`row align-items-center cs_gap_y_45 ${isHebrew ? '' : 'flex-row-reverse cs_gap_x_10'}`}>
            <div className="col-lg-6">
              <SectionHeading
                title={t("contactForm.title")}
                subTitle={t("contactForm.subtitle")}
              />
              <div className="cs_height_55 cs_height_lg_30" />
            </div>
            <div className="col-lg-6">
              <div className="cs_contact_form_wrap">
                <div className="cs_gray_bg_3 cs_contact_form_bg" />
                <form ref={form} onSubmit={onSubmit} className="cs_contact_form">
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    {t('contactForm.fullName')}
                  </label>
                  <input
                    placeholder={t('contactForm.fullNamePlaceholder')}
                    type="text"
                    name="user_name"
                    className="cs_form_field"
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    {t('contactForm.validEmail')}
                  </label>
                  <input
                    placeholder={t('contactForm.emailPlaceholder')}
                    type="text"
                    name="user_email"
                    className="cs_form_field"
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    {t('contactForm.phoneNumber')}
                  </label>
                  <input
                    placeholder={t('contactForm.phonePlaceholder')}
                    type="text"
                    name="user_phone"
                    className="cs_form_field"
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    {t('contactForm.projectBrief')}
                  </label>
                  <textarea
                    cols={30}
                    rows={5}
                    placeholder={t('contactForm.projectBriefPlaceholder')}
                    className="cs_form_field"
                    name="user_message"
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <button type="submit" value="Send" className="cs_btn cs_style_1">
                    {t('contactForm.submit')}
                    <span>
                      <i>
                        <Icon icon="fa6-solid:arrow-right" />
                      </i>
                      <i>
                        <Icon icon="fa6-solid:arrow-right" />
                      </i>
                    </span>
                  </button>
                </form>
                <Spacing lg="34" md="10" />
                {confirmationMessage && (
                  <div className="cs_confirmation_message">{confirmationMessage}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Video Play  */}
      {/* <div className="container">
        <Spacing lg="126" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/embed/VcaAVWtP48A"
          bgUrl="/images/creative-agency/hero_video_bg_1.jpeg"
          title="Our Design and Technology <br /> Studio is dedicated to making <br />your ideas a reality"
        />
      </div> */}

      {/* some recent news */}
      {/* <section className="cs_p76_full_width">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Some recent news" subTitle="Our Blog" />
          <Spacing lg="85" md="45" />
        </div>
        <PostCarousel data={postData} />
      </section> */}

      {/* <Marquee text="We Create Design - Build App - Website - Branding - SEO" /> */}
      <Spacing lg="54" md="20" />

      {/* Brands */}
      {/* <div className="container">
        <Brands data={darkMode ? brandListDark : brandList} />
      </div> */}
    </>
  );
}
